(function() {
  'use strict';

  /* ── Config (populated by Liquid JSON block in cart-template.liquid) ── */

  var configEl = document.getElementById('cart-config');
  if (!configEl) return;
  var CFG = JSON.parse(configEl.textContent);
  var S = CFG.strings;

  /* ── Shared utilities ── */

  var CURRENCY = CFG.currency;

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: CURRENCY }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function formatMoneyRound(cents) {
    return '$' + (cents / 100).toFixed(0);
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return (root || document).querySelectorAll(sel); }

  function waitFor(testFn, callback, interval, maxAttempts) {
    var n = 0;
    var id = setInterval(function() {
      if (testFn() || ++n >= maxAttempts) {
        if (n >= maxAttempts) callback(false);
        clearInterval(id);
      }
    }, interval);
  }

  /* ── Discount Thermometer ── */

  var thermoEl = document.getElementById('cart-thermometer');
  var tiers = [];
  var activeDiscountCode = '';

  if (thermoEl) {
    tiers = [1, 2, 3].map(function(n) {
      return {
        amount: parseInt(thermoEl.dataset['tier' + n + 'Amount'], 10),
        pct:    parseInt(thermoEl.dataset['tier' + n + 'Pct'], 10),
        code:   thermoEl.dataset['tier' + n + 'Code'] || ''
      };
    });

    tiers.forEach(function(t, i) {
      var n = i + 1;
      document.getElementById('thermo-amt' + n).textContent = '$' + (t.amount / 100);
      document.getElementById('thermo-pct' + n).textContent = S.thermoPctOff.replace('[pct]', t.pct);
    });
  }

  function getActiveTier(totalCents) {
    for (var i = 2; i >= 0; i--) {
      if (totalCents >= tiers[i].amount) return i;
    }
    return -1;
  }

  function updateThermometer(totalCents) {
    if (!thermoEl) return;

    var fill = document.getElementById('thermo-fill');
    var heading = document.getElementById('thermo-heading');
    var subtitle = document.getElementById('thermo-subtitle');
    var reached = getActiveTier(totalCents);

    /* Fill percentage */
    var pct = totalCents >= tiers[2].amount ? 100
      : totalCents >= tiers[1].amount ? 66.66 + (totalCents - tiers[1].amount) / (tiers[2].amount - tiers[1].amount) * 33.34
      : totalCents >= tiers[0].amount ? 33.33 + (totalCents - tiers[0].amount) / (tiers[1].amount - tiers[0].amount) * 33.33
      : totalCents / tiers[0].amount * 33.33;

    fill.style.width = Math.min(pct, 100) + '%';

    /* Milestone dots */
    tiers.forEach(function(t, j) {
      var n = j + 1;
      var method = totalCents >= t.amount ? 'add' : 'remove';
      document.getElementById('thermo-dot' + n).classList[method]('reached');
      document.getElementById('thermo-label' + n).classList[method]('reached');
    });

    /* Heading + subtitle */
    var isMax = reached === 2;
    thermoEl.classList.toggle('cart-thermometer--max', isMax);
    thermoEl.classList.toggle('cart-thermometer--unlocked', reached >= 0 && !isMax);
    fill.classList.toggle('cart-thermometer__fill--max', isMax);
    fill.classList.toggle('cart-thermometer__fill--active', reached >= 0 && !isMax);

    if (isMax) {
      heading.innerHTML = S.thermoUnlocked.replace('[pct]', tiers[2].pct);
      subtitle.textContent = S.thermoSubtitleMax;
    } else if (reached >= 0) {
      var next = tiers[reached + 1];
      heading.innerHTML = S.thermoUnlocked.replace('[pct]', tiers[reached].pct);
      subtitle.innerHTML = S.thermoSubtitleNext
        .replace('[amount]', formatMoneyRound(next.amount - totalCents))
        .replace('[pct]', next.pct);
    } else {
      heading.textContent = S.thermoHeadingDefault;
      subtitle.innerHTML = S.thermoSubtitleNext
        .replace('[amount]', formatMoneyRound(tiers[0].amount - totalCents))
        .replace('[pct]', tiers[0].pct);
    }
  }

  /* ── Visual discount prices (aesthetic only) ── */

  function toggleDiscount(origSpan, discSpan, cents, multiplier, active) {
    if (!origSpan || !discSpan) return;
    if (active) {
      origSpan.classList.add('cart-price--was');
      discSpan.textContent = formatMoney(Math.round(cents * multiplier));
      discSpan.style.display = '';
    } else {
      origSpan.classList.remove('cart-price--was');
      discSpan.style.display = 'none';
    }
  }

  function updateCartPrices(totalCents) {
    if (!tiers.length) return;
    var tierIdx = getActiveTier(totalCents);
    var pct = tierIdx >= 0 ? tiers[tierIdx].pct : 0;
    var active = pct > 0;
    var multiplier = active ? (1 - pct / 100) : 0;

    /* Line item unit prices */
    $$('.cart-card__price[data-unit-price]').forEach(function(el) {
      toggleDiscount(
        $('.cart-card__unit-original', el),
        $('.cart-card__unit-discounted', el),
        parseInt(el.dataset.unitPrice, 10), multiplier, active
      );
    });

    /* Line totals */
    $$('.cart-card__line-total[data-line-price]').forEach(function(el) {
      toggleDiscount(
        $('.cart-card__line-original', el),
        $('.cart-card__line-discounted', el),
        parseInt(el.dataset.linePrice, 10), multiplier, active
      );
    });

    /* Order summary subtotal */
    var sub = document.getElementById('cart-summary-subtotal');
    if (sub) toggleDiscount($('.cart-summary__subtotal-original', sub), $('.cart-summary__subtotal-discounted', sub), parseInt(sub.dataset.subtotal, 10), multiplier, active);

    /* Order summary total */
    var tot = document.getElementById('cart-summary-total');
    if (tot) toggleDiscount($('.cart-summary__total-original', tot), $('.cart-summary__total-discounted', tot), parseInt(tot.dataset.total, 10), multiplier, active);

    /* Sticky bar total */
    var sticky = $('.sticky-cart__total[data-sticky-total]');
    if (sticky) toggleDiscount($('.sticky-cart__total-original', sticky), $('.sticky-cart__total-discounted', sticky), parseInt(sticky.dataset.stickyTotal, 10), multiplier, active);
  }

  function updateAll(totalCents) {
    updateThermometer(totalCents);
    updateCartPrices(totalCents);
    var tierIdx = getActiveTier(totalCents);
    activeDiscountCode = (tierIdx >= 0 && tiers[tierIdx].code) ? tiers[tierIdx].code : '';
  }

  /* Initial render */
  if (thermoEl) {
    updateAll(parseInt(thermoEl.dataset.cartTotal, 10) || 0);
  }

  /* ── Countdown timer ── */

  var timerEl = document.getElementById('cart-timer');
  if (timerEl) {
    var TOTAL = CFG.countdownDuration;
    var STORAGE_KEY = 'cart_countdown_end';

    setInterval(function() {
      var end = sessionStorage.getItem(STORAGE_KEY);
      var remaining = end ? Math.floor((parseInt(end, 10) - Date.now()) / 1000) : 0;
      if (remaining <= 0) {
        sessionStorage.setItem(STORAGE_KEY, Date.now() + TOTAL * 1000);
        remaining = TOTAL;
      }
      var m = Math.floor(remaining / 60);
      var s = remaining % 60;
      timerEl.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    }, 1000);

    /* Trigger first tick immediately */
    var end = sessionStorage.getItem(STORAGE_KEY);
    if (!end || Math.floor((parseInt(end, 10) - Date.now()) / 1000) <= 0) {
      sessionStorage.setItem(STORAGE_KEY, Date.now() + TOTAL * 1000);
    }
    var r = Math.floor((parseInt(sessionStorage.getItem(STORAGE_KEY), 10) - Date.now()) / 1000);
    timerEl.textContent = Math.floor(r / 60) + ':' + ((r % 60) < 10 ? '0' : '') + (r % 60);
  }

  /* ── Sticky countdown banner ── */

  var countdownBanner = $('.cart-countdown-banner');
  var countdownSpacer = $('.cart-countdown-banner-spacer');
  var benefitsBanner = $('.product-benefits-banner');

  if (countdownBanner && countdownSpacer) {
    var bannerTop = countdownBanner.offsetTop;
    var isBannerSticky = false;

    function getTopOffset() {
      return (benefitsBanner && benefitsBanner.classList.contains('sticky-active')) ? benefitsBanner.offsetHeight : 0;
    }

    var stickyTicking = false;
    window.addEventListener('scroll', function() {
      if (stickyTicking) return;
      stickyTicking = true;
      requestAnimationFrame(function() {
        var threshold = bannerTop - getTopOffset();
        if (window.scrollY >= threshold && !isBannerSticky) {
          countdownBanner.classList.add('sticky-active');
          countdownSpacer.classList.add('active');
          isBannerSticky = true;
        } else if (window.scrollY < threshold && isBannerSticky) {
          countdownBanner.classList.remove('sticky-active');
          countdownBanner.style.top = '';
          countdownSpacer.classList.remove('active');
          isBannerSticky = false;
        }
        if (isBannerSticky) countdownBanner.style.top = getTopOffset() + 'px';
        stickyTicking = false;
      });
    });

    window.addEventListener('resize', function() {
      bannerTop = countdownSpacer.classList.contains('active') ? countdownSpacer.offsetTop : countdownBanner.offsetTop;
    });
  }

  /* ── Shipping cutoff ── */

  (function() {
    var eastern = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
    var hour = eastern.getHours();
    var day = eastern.getDay();
    var isWeekend = day === 0 || day === 6;
    var isFridayAfternoon = day === 5 && hour >= 12;

    var shortMsg, longTitle, longDesc;
    if (isWeekend || isFridayAfternoon) {
      shortMsg = S.shipsMondayShort;
      longTitle = S.shipsMondayLong;
      longDesc = isWeekend ? S.shipsMondayDescWeekend : S.shipsMondayDescFriday;
    } else if (hour < 12) {
      shortMsg = S.shipsTodayShort;
      longTitle = S.shipsTodayLong;
      longDesc = S.shipsTodayDesc;
    } else {
      shortMsg = S.shipsTomorrowShort;
      longTitle = S.shipsTomorrowLong;
      longDesc = S.shipsTomorrowDesc;
    }

    var el;
    if ((el = document.getElementById('sticky-shipping-text'))) el.textContent = shortMsg;
    if ((el = document.getElementById('trust-shipping-title'))) el.textContent = longTitle;
    if ((el = document.getElementById('trust-shipping-desc'))) el.textContent = longDesc;
  })();

  /* ── Judge.me badges ── */

  function fixBadgeVisibility() {
    $$('.cart-card .jdgm-preview-badge, .cart-upsell__info .jdgm-preview-badge').forEach(function(badge) {
      var inner = badge.querySelector('.jdgm-prev-badge');
      var count = inner ? parseInt(inner.getAttribute('data-number-of-reviews')) : 0;
      badge.style.display = count > 0 ? '' : 'none';
      if (inner && count > 0) inner.style.display = 'block';
    });
  }

  function refreshBadges() {
    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      window.jdgm.customizeBadges();
      setTimeout(fixBadgeVisibility, 100);
    } else {
      fixBadgeVisibility();
    }
  }

  /* Init: retry until jdgm loads */
  if (!(window.jdgm && window.jdgm.customizeBadges)) {
    waitFor(
      function() {
        if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
          window.jdgm.customizeBadges();
          setTimeout(fixBadgeVisibility, 100);
          return true;
        }
        return false;
      },
      function() { fixBadgeVisibility(); },
      500, 10
    );
  } else {
    refreshBadges();
  }

  /* ── Shared AJAX cart DOM refresh ── */

  function refreshCartDOM(sections) {
    var tmp = document.createElement('div');
    tmp.innerHTML = sections['cart-template'];

    var oldItems = $('.cart-items-column');
    var newItems = $('.cart-items-column', tmp);

    if (oldItems && newItems) {
      var newCards = $$('.cart-card', newItems);
      if (newCards.length === 0) { window.location.reload(); return; }

      $$('.cart-card', oldItems).forEach(function(c) { c.remove(); });

      /* Insert after thermometer (or h1) — keeps order: H1 → Thermometer → Cards → Bulbs */
      var thermo = $('.cart-thermometer', oldItems);
      var h1 = $('h1', oldItems);
      var ref = thermo ? thermo.nextElementSibling : (h1 ? h1.nextElementSibling : oldItems.firstElementChild);
      newCards.forEach(function(c) { oldItems.insertBefore(c, ref); });
    }

    /* Order summary */
    var newSummary = $('.cart-summary', tmp);
    var oldSummary = $('.cart-summary');
    if (newSummary && oldSummary) oldSummary.innerHTML = newSummary.innerHTML;

    /* Sticky bar total */
    var newTotal = $('.sticky-cart__total', tmp);
    var oldTotal = $('.sticky-cart__total');
    if (newTotal && oldTotal) {
      oldTotal.innerHTML = newTotal.innerHTML;
      if (newTotal.dataset.stickyTotal) oldTotal.dataset.stickyTotal = newTotal.dataset.stickyTotal;
    }

    refreshBadges();

    /* Update cart count + thermometer/prices */
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      $$('.cart-count, .cart_count, [data-cart-count]').forEach(function(el) {
        el.textContent = cart.item_count;
      });
      updateAll(cart.total_price);
    });
  }

  /* ── AJAX cart update (remove & qty change) ── */

  var cartUpdating = false;

  function cartChange(line, qty, card) {
    if (cartUpdating) return;
    cartUpdating = true;

    $$('.cart-card__qty .js-change-quantity').forEach(function(b) {
      b.style.pointerEvents = 'none';
      b.style.opacity = '0.5';
    });

    if (qty === 0 && card) {
      card.style.opacity = '0.4';
      card.style.pointerEvents = 'none';
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line), quantity: qty })
    })
    .then(function(r) { if (!r.ok) throw new Error('Cart update failed'); })
    .then(function() { return fetch('/cart?sections=cart-template'); })
    .then(function(r) { return r.json(); })
    .then(refreshCartDOM)
    .catch(function() {
      fetch('/cart?sections=cart-template').then(function(r) { return r.json(); }).then(refreshCartDOM);
    })
    .finally(function() { cartUpdating = false; });
  }

  /* ── AJAX add to cart (bulbs & upsell) ── */

  function ajaxAddToCart(variantId, btn) {
    if (!variantId) { alert(S.variantNotFound); return; }

    var allButtons = $$('.cart-bulbs__add, .cart-upsell__add');
    allButtons.forEach(function(b) { b.disabled = true; });
    var origText = btn.textContent;
    btn.textContent = S.adding;

    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');

    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function(r) {
        if (!r.ok) return r.json().then(function(err) { throw new Error(err.description || S.addFailed); });
        return r.json();
      })
      .then(function() {
        btn.textContent = S.added;
        btn.style.background = '#27ae60';
        btn.style.color = '#fff';
        setTimeout(function() {
          btn.textContent = origText;
          btn.style.background = '';
          btn.style.color = '';
          btn.disabled = false;
        }, 2000);

        return fetch('/cart?sections=cart-template').then(function(r) { return r.json(); });
      })
      .then(function(sections) {
        refreshCartDOM(sections);
        allButtons.forEach(function(b) { b.disabled = false; });
      })
      .catch(function(error) {
        allButtons.forEach(function(b) { b.disabled = false; });
        btn.textContent = origText;
        alert(error.message || S.addFailed);
      });
  }

  /* ── Delegated event handlers (no rebinding needed after DOM swap) ── */

  /* Remove item */
  document.addEventListener('click', function(e) {
    var link = e.target.closest('.cart-card__remove');
    if (!link) return;
    e.preventDefault();
    var card = link.closest('.cart-card');
    var line = card ? card.dataset.line : null;
    if (line) cartChange(line, 0, card);
  });

  /* Quantity +/- buttons */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cart-card__qty .js-change-quantity');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input.quantity');
    var card = btn.closest('.cart-card');
    var line = card ? card.dataset.line : null;
    if (!input || !line) return;
    /* Defer to let jQuery's handler update the value first */
    setTimeout(function() { cartChange(line, parseInt(input.value), card); }, 0);
  });

  /* Bulbs & upsell add buttons */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cart-bulbs__add[data-variant-id], .cart-upsell__add[data-variant-id]');
    if (btn) ajaxAddToCart(btn.dataset.variantId, btn);
  });

  /* Form submit — block default, handle checkout with discount code */
  var cartForm = document.getElementById('cart_form');
  if (cartForm) {
    cartForm.addEventListener('submit', function(e) {
      var sub = e.submitter;
      var isCheckout = sub && (sub.name === 'checkout' || sub.id === 'checkout' || sub.id === 'sticky-checkout-btn');
      if (isCheckout && activeDiscountCode) {
        e.preventDefault();
        window.location.href = '/discount/' + encodeURIComponent(activeDiscountCode) + '?redirect=/checkout';
        return;
      }
      if (!isCheckout) e.preventDefault();
    });
  }

  /* ── Upsell recommendations ── */

  (function() {
    var wrapper = document.getElementById('cart-upsell-wrapper');
    var grid = document.getElementById('cart-upsell-grid');
    if (!wrapper || !grid) return;

    var productIds = (wrapper.dataset.productIds || '').split(',').filter(Boolean);
    if (!productIds.length) return;

    var seedId = productIds[0];
    var inCart = {};
    productIds.forEach(function(id) { inCart[id] = true; });

    function filterProducts(data) {
      return (data.products || []).filter(function(p) {
        return p.available && !inCart[String(p.id)];
      }).slice(0, 5);
    }

    function fetchRecs(intent) {
      return fetch('/recommendations/products.json?product_id=' + seedId + '&limit=10&intent=' + intent)
        .then(function(r) { if (!r.ok) throw new Error(); return r.json(); });
    }

    fetchRecs('complementary')
      .then(function(data) {
        var products = filterProducts(data);
        return products.length ? products : fetchRecs('related').then(filterProducts);
      })
      .then(function(products) {
        if (!products || !products.length) return;

        grid.innerHTML = products.map(function(p) {
          var vid = p.variants[0] ? p.variants[0].id : '';
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var cp = p.compare_at_price;
          var safe = (p.title || '').replace(/"/g, '&quot;');

          return '<div class="cart-upsell__item" data-variant-id="' + vid + '">'
            + '<a href="' + p.url + '" class="cart-upsell__image">'
            + (img ? '<img src="' + img + '" alt="' + safe + '" loading="lazy" width="400" height="400">' : '')
            + '</a><div class="cart-upsell__info">'
            + '<p class="cart-upsell__name">' + p.title + '</p>'
            + '<div class="jdgm-widget jdgm-preview-badge" data-id="' + p.id + '" data-auto-install="false"></div>'
            + '<p class="cart-upsell__price">'
            + (cp && cp > p.price ? '<span class="money was-price">' + formatMoney(cp) + '</span> ' : '')
            + '<span class="money">' + formatMoney(p.price) + '</span></p></div>'
            + (vid ? '<button type="button" class="cart-upsell__add action_button" data-variant-id="' + vid + '">' + S.addToCart + '</button>' : '')
            + '</div>';
        }).join('');

        wrapper.style.display = '';
        refreshBadges();
        initUpsellCarousel();
      })
      .catch(function() { /* Silently fail — section stays hidden */ });

    function initUpsellCarousel() {
      var prevBtn = document.getElementById('upsell-prev');
      var nextBtn = document.getElementById('upsell-next');
      if (!prevBtn || !nextBtn) return;

      function scrollAmt() {
        var first = $('.cart-upsell__item', grid);
        return first ? first.offsetWidth + 14 : Math.round(grid.clientWidth / 5) + 14;
      }

      function smoothScroll(el, left) {
        try { el.scrollTo({ left: left, behavior: 'smooth' }); } catch (e) { el.scrollLeft = left; }
      }

      nextBtn.addEventListener('click', function() {
        var amt = scrollAmt();
        smoothScroll(grid, grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 10 ? 0 : grid.scrollLeft + amt);
      });
      prevBtn.addEventListener('click', function() {
        var amt = scrollAmt();
        smoothScroll(grid, grid.scrollLeft <= 10 ? grid.scrollWidth : grid.scrollLeft - amt);
      });
    }
  })();

  /* ── Sticky checkout bar ── */

  document.addEventListener('DOMContentLoaded', function() {
    var stickyBar = document.getElementById('sticky-cart-checkout');
    var checkoutBtn = document.getElementById('checkout');
    var footer = $('footer') || $('.footer') || document.getElementById('footer');
    if (!stickyBar || !checkoutBtn) return;

    if (window.innerWidth <= 798) {
      /* Mobile: always visible, hide at page bottom */
      stickyBar.classList.add('is-visible');
      window.addEventListener('scroll', function() {
        var atBottom = (window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 5);
        stickyBar.classList.toggle('is-visible', !atBottom);
      }, { passive: true });
    } else {
      /* Desktop: show when checkout button scrolls out of view */
      var hasScrolled = false, checkoutVisible = true, footerVisible = false;

      function updateBar() {
        stickyBar.classList.toggle('is-visible', hasScrolled && !checkoutVisible && !footerVisible);
      }

      var barTicking = false;
      window.addEventListener('scroll', function() {
        if (barTicking) return;
        barTicking = true;
        requestAnimationFrame(function() {
          var scrolled = window.scrollY > 100;
          if (hasScrolled !== scrolled) { hasScrolled = scrolled; updateBar(); }
          barTicking = false;
        });
      }, { passive: true });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function(entries) {
          checkoutVisible = entries[0].isIntersecting;
          updateBar();
        }, { threshold: 0, rootMargin: '-5px 0px 0px 0px' }).observe(checkoutBtn);

        if (footer) {
          new IntersectionObserver(function(entries) {
            footerVisible = entries[0].isIntersecting;
            updateBar();
          }, { threshold: 0 }).observe(footer);
        }
      }
    }

    /* Sticky checkout — validate ToS checkbox */
    var stickyCheckoutBtn = document.getElementById('sticky-checkout-btn');
    var tosCheckbox = document.getElementById('cart_agree');
    if (stickyCheckoutBtn && tosCheckbox) {
      stickyCheckoutBtn.addEventListener('click', function(e) {
        if (!tosCheckbox.checked) {
          e.preventDefault();
          tosCheckbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function() { tosCheckbox.reportValidity(); }, 400);
        }
      });
    }
  });

  /* ── Reviewer name fill (Judge.me single-letter → full name) ── */

  var nameMap = {
    A:'Amanda', B:'Barbara', C:'Christine', D:'Diane', E:'Emily',
    F:'Frances', G:'Gloria', H:'Heather', I:'Irene', J:'Jennifer',
    K:'Karen', L:'Laura', M:'Margaret', N:'Nancy', O:'Olivia',
    P:'Patricia', Q:'Quinn', R:'Rachel', S:'Susan', T:'Teresa',
    U:'Ursula', V:'Victoria', W:'Wendy', X:'Xena', Y:'Yvonne', Z:'Zoe'
  };

  waitFor(
    function() {
      var els = $$('.jdgm-carousel-item__reviewer-name');
      if (!els.length) return false;
      var changed = false;
      els.forEach(function(el) {
        var n = el.textContent.trim();
        if (n.length === 1 && nameMap[n.toUpperCase()]) {
          el.textContent = ' ' + nameMap[n.toUpperCase()] + ' ';
          changed = true;
        }
      });
      return changed;
    },
    function() { /* gave up — names stay as-is */ },
    500, 20
  );

})();
